import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { useWindowWidth } from "@/hooks/useWindowWidth";
import * as StyledAccordion from "./Styled.Accordion";
import * as StyledTypography from "@/styles/Styled.Typography";
import * as StyledButtons from "@/styles/Styled.Buttons";
import { Link } from "react-router-dom";

const AccordionHighlights = ({
  title,
  id,
  content,
  label,
  cta,
  link,
  expanded,
  setExpanded,
}) => {
  const ref = useRef();
  const windowWidth = useWindowWidth();
  const isLargeScreen = windowWidth >= 900;

  // Apply animation effect using GSAP
  useEffect(() => {
    const isOpen = isLargeScreen ? id === expanded : true; // Always expand for lg and xl, expand for others based on id
    gsap.to(ref.current.children[1], {
      width: isOpen ? "auto" : 0,
      duration: 0.5,
      ease: "power3.inOut",
    });
  }, [expanded, windowWidth, id, isLargeScreen]);

  const handleAccordionClick = () => {
    if (isLargeScreen && id !== expanded) {
      // Only set expanded state if it's lg or xl breakpoint
      setExpanded(id);
    }
  };

  return (
    <StyledAccordion.HighlightsItem ref={ref}>
      <StyledAccordion.HighlightsItemHeaderWrapper
        onClick={windowWidth >= 900 ? handleAccordionClick : null}
      >
        <StyledAccordion.HighlightsItemHeaderInner>
          <StyledTypography.TypoTitle1 as="h3">
            {title}
          </StyledTypography.TypoTitle1>
          <StyledAccordion.HighlightsItemHeaderLabelWrapper>
            <StyledAccordion.HighlightsItemHeaderLabel as="small">
              {label}
            </StyledAccordion.HighlightsItemHeaderLabel>
          </StyledAccordion.HighlightsItemHeaderLabelWrapper>
        </StyledAccordion.HighlightsItemHeaderInner>
      </StyledAccordion.HighlightsItemHeaderWrapper>

      <StyledAccordion.HighlightsItemContentWrapper>
        <StyledAccordion.HighlightsItemContentInner>
          <StyledTypography.TypoBody2>{content}</StyledTypography.TypoBody2>
          <Link to={link}>
            <StyledButtons.PrimaryButton as="button">
              {cta}
            </StyledButtons.PrimaryButton>
          </Link>
        </StyledAccordion.HighlightsItemContentInner>
      </StyledAccordion.HighlightsItemContentWrapper>
    </StyledAccordion.HighlightsItem>
  );
};

export default AccordionHighlights;
